import Bowser from "bowser";
import { Platform } from "react-native";

export function getBrowserInfo() {
  if (Platform.OS !== "web") return;
  const userAgent = navigator.userAgent;
  return Bowser.getParser(userAgent).getResult();
}

export function isMobileWeb() {
  const browserInfo = getBrowserInfo();
  return browserInfo?.platform?.type === "mobile";
}

export function isMobileWebkit() {
  const browserInfo = getBrowserInfo();
  if (!browserInfo) return false;
  return (
    isMobileWeb() &&
    browserInfo.os?.name === "iOS" &&
    browserInfo.engine?.name === "WebKit"
  );
}

/**
 * This waits for the browser to be idle/settled, similar to waitFor in testing libraries
 * @param callback - The callback to execute when the browser is idle/settled
 */
export function waitForSettled(callback: () => void): void {
  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    window.requestIdleCallback(callback, { timeout: 1000 });
  } else {
    // Fallback approximates requestIdleCallback by waiting for paint cycle
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // setTimeout to wait for other processes to settle
        setTimeout(callback, 0);
      });
    });
  }
}
